import moment from 'moment-timezone';
import { v4 as uuid } from 'uuid';
import { FlowyGlobal } from '../../flowy';
import {
  IRealmUserEvent,
  TUserEventCategory,
  TUserEventType,
} from '../../types';

interface IParams {
  category: TUserEventCategory;
  type: TUserEventType;
  context: {
    global: FlowyGlobal;
  };
}

async function createUserEvent({ category, type, context }: IParams) {
  const { global } = context;
  let event: IRealmUserEvent | undefined;
  const user = await global.getPlatformInterface()?.getUser();
  const database = global.getDatabase();

  if (
    category === 'session' &&
    (type === 'loggedIn' || type === 'loggedOut') &&
    user
  ) {
    event = {
      fid: uuid(),
      category,
      type,
      userId: user.id,
      timestamp: Math.floor(Date.now() / 1000),
      timezone: moment.tz.guess(),
      uploaded: false,
    };
  }

  if (event && database) {
    await database.set({
      type: 'userEvents',
      value: event,
    });
  }
}

export default createUserEvent;
